import HoldingSettlementPage from './HoldingSettlementPage';

const SettlementQueue = () => (
    <HoldingSettlementPage
        title="Settlement Queue"
        breadcrumbTitle="Settlement Queue"
    />
);

export default SettlementQueue;
